/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_HInputs */

const en_wc_tut_keys_h = /** @type {(inputs: Wc_Tut_Keys_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Keyboard shortcuts`)
};

/**
* | output |
* | --- |
* | "8. Keyboard shortcuts" |
*
* @param {Wc_Tut_Keys_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_h = /** @type {((inputs?: Wc_Tut_Keys_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_h(inputs)
});
export { wc_tut_keys_h as "wc.tut.keys.h" }